<template>
  <v-app class="no-border">
    <v-content>
      <v-container class="pa-0 fill-height" fluid>
        <v-row class="fill-height">
          <v-col cols="12" md="6" sm="12" lg="5">
            <v-row class="pa-7 fill-height" align="center" justify="center">
              <v-col class="pa-3" cols="12">
                <a href="https://www.himydata.com"
                  ><img src="@/assets/img/Logotype_Light.png" height="45px"
                /></a>

                <h1 class="font-weight-light  my-5">
                  Welcome back
                </h1>
                <h3 class="thin mb-4 dark">
                  Don't have an account ?
                  <a href="/signup">Sign up</a>
                </h3>
                <v-text-field
                  v-model="signinForm.email"
                  v-validate="'required|email'"
                  placeholder="E-mail address"
                  :error-messages="errors.collect('email')"
                  solo
                  data-vv-name="email"
                  required
                />
                <v-text-field
                  v-model="signinForm.password"
                  v-validate="'required|min:8'"
                  :type="passwordType"
                  autocomplete="off"
                  placeholder="Password"
                  :error-messages="errors.collect('password')"
                  data-vv-name="password"
                  required
                  solo
                  :append-icon="eyeIcon"
                  @keyup.enter="submit"
                  @click:append="togglePassword"
                />
                <vue-recaptcha
                  v-if="rcapt_required"
                  ref="recaptcha"
                  size="invisible"
                  :sitekey="rcapt_sig_key"
                  @verify="onCaptchaVerified"
                  @expired="onCaptchaExpired"
                />
                <v-btn
                  large
                  block
                  color="primary"
                  :disabled="errors.any()"
                  class="my-3"
                  @click="submit"
                  @keyup.enter="submit"
                >
                  Sign in
                </v-btn>
                <recover-password /><br />
                <resend-activation-email />
              </v-col>
            </v-row>
          </v-col>
          <v-col class="bg-cover hidden-xs-only hidden-sm-only md-6 lg-7">
            <h2 class="white--text pa-5 mt-5 text-center">
              We helps your business grow without compromise.
            </h2>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <notify />
  </v-app>
</template>
<script>
import RecoverPassword from "./../../../UIComponents/RecoverPassword";
import ResendActivationEmail from "./../../../UIComponents/ResendActivationEmail";
import { login } from "@/utils/auth";
import VueRecaptcha from "vue-recaptcha";

export default {
  $_veeValidate: {
    validator: "new"
  },
  components: { VueRecaptcha, RecoverPassword, ResendActivationEmail },
  metaInfo() {
    return {
      title: "Himydata"
    };
  },
  data: function() {
    return {
      rcapt_required: false,
      rcapt_sig_key: "6LftEnkUAAAAAFBTpGynofYjcaKMloUyEmB6xQo4",
      signinForm: {
        email: "",
        password: ""
      },
      signinDictionary: {
        attributes: {
          email: "E-mail Address"
          // custom attributes
        },
        custom: {
          password: {
            required: () => "Name can not be empty",
            max: "The name field may not be greater than 10 characters"
            // custom messages
          }
        }
      },
      notif: {
        snackbar: false,
        color: "error",
        mode: "",
        timeout: 3000,
        text: ""
      },
      eyeIcon: "mdi-eye",
      passwordType: "password"
    };
  },
  mounted: function() {
    /* this.$validator.localize('fr', this.signinDictionary) */
    if (process.env.RECAPTCHA_REQUIRED) {
      this.rcapt_required = process.env.RECAPTCHA_REQUIRED;
    }
    this.clear();
  },
  methods: {
    submit() {
      if (this.rcapt_required) {
        this.$refs.recaptcha.execute();
      } else {
        this.call_login();
      }
    },
    call_login(recaptchaToken = null) {
      var credentials = {
        email: this.signinForm.email,
        password: this.signinForm.password
      };

      if (this.rcapt_required) {
        credentials.recaptchaToken = recaptchaToken;
      }

      login(this, credentials, this.$route.query.redirect);
    },
    onCaptchaExpired: function() {
      if (this.rcapt_required) {
        this.$refs.recaptcha.reset();
      }
    },
    onCaptchaVerified: function(recaptchaToken) {
      if (this.rcapt_required) {
        this.$refs.recaptcha.reset();
      }

      this.$validator.validateAll().then(result => {
        if (result) {
          this.call_login(recaptchaToken);
        }
      });
    },
    clear() {
      this.signinForm.email = "";
      this.signinForm.password = "";
      this.signinForm.checkbox = null;
      this.$validator.reset();
      if (this.rcapt_required) {
        this.$refs.recaptcha.reset();
      }
    },
    togglePassword() {
      this.passwordType = this.passwordType == "password" ? "text" : "password";
      this.eyeIcon =
        this.passwordType == "password" ? "mdi-eye" : "mdi-eye-off";
    }
  }
};
</script>
<style>
.bg-cover {
  background-color: #1a1c24 !important;
  background-image: url(/img/hmd-signin.svg) !important;
  background-size: 45% !important;
}
.pa-7 {
  padding: 70px;
}
.thin {
  font-weight: 300;
}

@media only screen and (max-width: 450px) {
  .pa-7 {
    padding: 35px;
  }
}
</style>
